import React from 'react';
import Box from '@nubank/nuds-web/components/Box/Box';
import styled from 'styled-components';
import Image from '@nubank/nuds-web/components/Image/Image';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import PropTypes from 'prop-types';

const StyledTitleIcon = styled(Image)`
  position: absolute;
  margin-top: -50px;

  @media (width >= 768px) {
    left: 14px;
    margin-top: -40px;
  }
`;

const StyledRates = styled(Typography)`
  @media (width >= 1150px) {
    font-size: 1.2rem;
  }
`;

const StyledTypography = styled(Typography)`
  @media (width >= 1150px) {
    font-size: 2rem;
  }
`;

const StyledSubtitleTypography = styled(Typography)`
  @media (width >= 1150px) {
    font-size: 1.2rem;
  }
`;

const StyledIconAndTitleContainer = styled.div`
  position: relative;
  background-color: #f8f8fa;
  border-radius: 12px;
  padding-left: 31px;
  padding-right: 31px;
  padding-bottom: 31px;

  span {
    /* stylelint-disable property-no-vendor-prefix, property-no-unknown */
    background-image: linear-gradient(137.07deg, #9F2DEB 42.83%, #6200A3 86.85%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }

  @media (width >= 1150px) {
    padding-left:40px;
    padding-right: 40px;
    padding-bottom: 40px;
  }
`;

const ContentBox = ({ displayOptions }) => (
  <Box
    position="relative"
    paddingHorizontal="32px"
    marginTop={{ xs: '-200px', lg: '0' }}
    maxWidth={{ xs: '100%', lg: '500px' }}
    flexDirection="column"
    justifyContent="center"
    margin="0 auto"
    display={displayOptions}
  >
    <StyledIconAndTitleContainer>
      <StyledTitleIcon
        webp={false}
        alt="Nu"
        src="credit-card/rates/rates-icon-new.svg"
        width={{ xs: '100px', lg: '101px' }}
      />
      <StyledTypography
        strong
        variant="heading2"
        height="100%"
        paddingTop={{ xs: '80px', lg: '90px' }}
        whiteSpace={{ xs: 'normal', lg: 'pre-line' }}
        textAlign="left"
      >

        Te damos transparencia y
        <span> claridad</span>
      </StyledTypography>

      <Box marginBottom="30px">
        <StyledSubtitleTypography
          strong
          variant="heading4"
          height="100%"
          paddingTop="40px"
          whiteSpace="pre-line"
          textAlign="left"
        >
          CAT Promedio
          {'\n'}
          <StyledRates tag="span" variant="heading3" intlKey="COMMON.CREDITO.CAT_PROMEDIO.DESCRIPTION" />
        </StyledSubtitleTypography>

        <StyledSubtitleTypography
          strong
          variant="heading4"
          height="100%"
          paddingTop="40px"
          whiteSpace="pre-line"
          textAlign="left"
        >
          Tasa Promedio Ponderada anual fija
          {'\n'}
          <StyledRates tag="span" variant="heading3" intlKey="COMMON.CREDITO.YEARLY_RATE.DESCRIPTION" />
        </StyledSubtitleTypography>

        <StyledSubtitleTypography
          strong
          variant="heading4"
          height="100%"
          paddingTop="40px"
          whiteSpace="pre-line"
          textAlign="left"
        >
          Comisión Anual
          {'\n'}
          <StyledRates tag="span" variant="heading3" intlKey="COMMON.CREDITO.ANNUAL_FEE.DESCRIPTION" />
        </StyledSubtitleTypography>
      </Box>

      <Typography
        variant="paragraph1"
        maxWidth={{ xs: '100%', lg: '435px' }}
        margin="0 auto"
        marginBottom={{ xs: '14px', lg: '40px' }}
        textAlign="left"
        intlKey="COMMON.CREDITO.LEGAL.DISCLAIMER"
      />
    </StyledIconAndTitleContainer>

  </Box>
);

ContentBox.propTypes = {
  displayOptions: PropTypes.string.isRequired,
};

export default ContentBox;
